import type { SVGProps } from "react";
export interface InboxArrowUpIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function InboxArrowUpIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: InboxArrowUpIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M20.875 15v-.845c0-.465-.066-.927-.197-1.371l-.152-.44-2.816-7.04a1.88 1.88 0 0 0-1.741-1.179H8.03c-.767 0-1.456.467-1.74 1.18l-2.817 7.04a4.9 4.9 0 0 0-.349 1.81V15a1.125 1.125 0 0 1-2.25 0v-.845c0-.906.173-1.804.51-2.646l2.817-7.041.127-.287A4.13 4.13 0 0 1 8.03 1.875h7.938a4.13 4.13 0 0 1 3.83 2.593l2.816 7.041c.336.842.51 1.74.51 2.646V15a1.125 1.125 0 0 1-2.25 0Z"
      />
      <path
        fill={color}
        d="M20.875 15a.875.875 0 0 0-.875-.876h-2.121l-.598 2.391a2.126 2.126 0 0 1-2.062 1.61H8.78a2.125 2.125 0 0 1-2.01-1.436l-.051-.174-.598-2.39H4a.875.875 0 0 0-.875.875v3c0 1.036.84 1.875 1.875 1.875h14c1.035 0 1.874-.84 1.875-1.875zm-10-2.5V9.216l-1.08 1.08a1.125 1.125 0 0 1-1.59-1.591l3-3 .171-.141a1.126 1.126 0 0 1 1.42.14l3 3 .076.086a1.125 1.125 0 0 1-1.582 1.583l-.085-.078-1.08-1.08V12.5a1.125 1.125 0 0 1-2.25 0m12.25 5.5A4.125 4.125 0 0 1 19 22.125H5A4.125 4.125 0 0 1 .875 18v-3A3.125 3.125 0 0 1 4 11.874h2.219c.914 0 1.72.584 2.011 1.436l.051.174.598 2.391h6.243l.598-2.39.051-.175a2.125 2.125 0 0 1 2.01-1.436H20c1.726 0 3.125 1.4 3.125 3.126z"
      />
    </svg>
  );
}
